import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';
import Logo from '../../assets/img/logo/logo-white-2.png';
import shapeImg from '../../assets/img/contact/shape-2-1.png';

const ChennaiBranch = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const faqData = [
    {
      question: "Does CBS HUB supply school books in Chennai?",
      answer: "Yes. CBS HUB Private Limited supplies bulk school books, custom kits and stationery to CBSE, ICSE and State Board (Samacheer Kalvi) schools in Chennai and across Tamil Nadu."
    },
    {
      question: "Can Chennai schools get class-wise supply kits from CBS HUB?",
      answer: "Yes. CBS HUB prepares class-wise kits containing textbooks, notebooks and stationery tailored to each school's curriculum and board requirements."
    },
    {
      question: "Does CBS HUB set up school libraries in Chennai?",
      answer: "Yes. Our library solutions team provides book curation, cataloguing and complete library setup for schools in Chennai and Tamil Nadu."
    },
    {
      question: "How does CBS HUB serve Chennai schools from Hyderabad?",
      answer: "CBS HUB operates a Pan-India supply chain with dedicated account managers for Chennai and Tamil Nadu schools ensuring timely institutional delivery each academic year."
    }
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <main>
      <Helmet>
        <title>B2B School Book & Kit Supplier Chennai | CBS HUB Central Books Tamil Nadu</title>
        <meta name="description" content="CBS HUB (Central Books) now serving Chennai, Tamil Nadu schools with bulk books, custom kits, stationery & library solutions. CBSE, ICSE & State Board institutional supply — B2B only." />
        <meta name="keywords" content="school book supplier Chennai, bulk books supplier Tamil Nadu, B2B school kit supplier Chennai, library solutions schools Chennai, CBSE ICSE book distributor Tamil Nadu" />
        <link rel="canonical" href="https://www.centralbooks.in/chennai-branch" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="B2B School Book & Kit Supplier Chennai | CBS HUB Central Books Tamil Nadu" />
        <meta property="og:description" content="CBS HUB (Central Books) now serving Chennai, Tamil Nadu schools with bulk books, custom kits, stationery & library solutions. CBSE, ICSE & State Board institutional supply — B2B only." />
        <meta property="og:url" content="https://www.centralbooks.in/chennai-branch" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.centralbooks.in/images/chennai-branch-og.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="B2B School Book & Kit Supplier Chennai | CBS HUB Central Books Tamil Nadu" />
        <meta name="twitter:description" content="CBS HUB (Central Books) now serving Chennai, Tamil Nadu schools with bulk books, custom kits, stationery & library solutions. CBSE, ICSE & State Board institutional supply — B2B only." />

        <script async src="https://www.googletagmanager.com/gtag/js?id=G-DLV3R29XHF"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-DLV3R29XHF');
          `}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.centralbooks.in/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Our Branches",
                "item": "https://www.centralbooks.in/ourbranches"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Chennai Branch",
                "item": "https://www.centralbooks.in/chennai-branch"
              }
            ]
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "CBS HUB Private Limited - Chennai Branch",
            "parentOrganization": {
              "@type": "Organization",
              "name": "CBS HUB Private Limited",
              "url": "https://www.centralbooks.in"
            },
            "url": "https://www.centralbooks.in/chennai-branch",
            "telephone": "+91-40-2409-8282",
            "email": "chennai@centralbooks.in",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Chennai",
              "addressRegion": "Tamil Nadu",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 13.0827,
              "longitude": 80.2707
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              "opens": "09:00",
              "closes": "18:00"
            },
            "description": "B2B school books, kits, stationery and library solutions for Chennai and Tamil Nadu schools"
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqData.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })}
        </script>
      </Helmet>

      <HeaderFour />
      <Breadcrumb title="B2B School Supply Partner in Chennai — CBS HUB Central Books" subTitle="Chennai Branch" />

      <div className="it-about-area pt-120 pb-80" style={{ background: '#f9fafb' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-7">
              <div className="it-about-left-box pr-30">
                <div className="it-section-title-wrap mb-30">
                  <span className="it-section-subtitle-5 orange" style={{ fontSize: '1.1rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Serving Tamil Nadu Schools</span>
                  <h2 className="it-section-title-3 mt-15 mb-25" style={{ fontSize: '2.5rem', lineHeight: '1.25', fontWeight: '800', color: '#111827' }}>
                    School Books, Kits & Stationery for Chennai's CBSE, ICSE & State Board Schools
                  </h2>
                  <p className="lead" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#374151', paddingBottom: '15px', fontWeight: '500' }}>
                    CBS HUB Private Limited (Central Books) — India's trusted B2B school supply company with 75+ years of experience — now serves CBSE, ICSE and State Board (Samacheer Kalvi) schools in Chennai and across Tamil Nadu. From bulk textbooks and class-wise kits to custom notebooks and library setup, we deliver end-to-end institutional supply. Contact our Chennai desk: 040 2409 8282 | chennai@centralbooks.in
                  </p>
                </div>
                <div className="row mb-30">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-15">
                      <span className="mr-10" style={{ color: '#ea580c', fontSize: '1.25rem' }}><i className="fa-solid fa-circle-check"></i></span>
                      <span style={{ fontWeight: '600', color: '#1f2937' }}>Customised Class-Wise Kits</span>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <span className="mr-10" style={{ color: '#ea580c', fontSize: '1.25rem' }}><i className="fa-solid fa-circle-check"></i></span>
                      <span style={{ fontWeight: '600', color: '#1f2937' }}>CBSE / ICSE Board Publications</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* <div className="d-flex align-items-center mb-15">
                      <span className="mr-10" style={{ color: '#ea580c', fontSize: '1.25rem' }}><i className="fa-solid fa-circle-check"></i></span>
                      <span style={{ fontWeight: '600', color: '#1f2937' }}>Samacheer Kalvi Textbooks</span>
                    </div> */}
                    <div className="d-flex align-items-center mb-15">
                      <span className="mr-10" style={{ color: '#ea580c', fontSize: '1.25rem' }}><i className="fa-solid fa-circle-check"></i></span>
                      <span style={{ fontWeight: '600', color: '#1f2937' }}>Custom School Branded Stationery</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <div className="it-contact__wrap fix z-index-3 p-relative" style={{ background: '#ffffff', padding: '40px', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)', border: '1px solid #e5e7eb' }}>
                <div className="it-contact__shape-1 d-none d-xl-block">
                  <img src={shapeImg} alt="" />
                </div>
                <h4 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#111827', marginBottom: '20px' }}>Contact Chennai Desk</h4>
                <p style={{ color: '#6b7280', fontSize: '0.95rem', marginBottom: '30px' }}>Get in touch with our institutional sales team for bulk quotes and orders.</p>
                <div className="it-contact__content">
                  <ul>
                    <li className="mb-20">
                      <div className="d-flex align-items-start">
                        <div className="mr-15" style={{ color: '#ea580c', fontSize: '1.2rem', marginTop: '3px' }}>
                          <i className="fa-solid fa-location-dot"></i>
                        </div>
                        <div>
                          <span style={{ display: 'block', fontWeight: '600', color: '#111827', fontSize: '0.9rem', textTransform: 'uppercase' }}>Serving Location</span>
                          <span style={{ color: '#4b5563', fontSize: '0.95rem' }}>Chennai Metro & Tamil Nadu Districts</span>
                        </div>
                      </div>
                    </li>
                    <li className="mb-20">
                      <div className="d-flex align-items-start">
                        <div className="mr-15" style={{ color: '#ea580c', fontSize: '1.2rem', marginTop: '3px' }}>
                          <i className="fa-solid fa-phone"></i>
                        </div>
                        <div>
                          <span style={{ display: 'block', fontWeight: '600', color: '#111827', fontSize: '0.9rem', textTransform: 'uppercase' }}>Phone Hotline</span>
                          <a href="tel:04024098282" style={{ color: '#ea580c', fontWeight: '700', fontSize: '1.1rem' }}>040 2409 8282</a>
                        </div>
                      </div>
                    </li>
                    <li className="mb-20">
                      <div className="d-flex align-items-start">
                        <div className="mr-15" style={{ color: '#ea580c', fontSize: '1.2rem', marginTop: '3px' }}>
                          <i className="fa-solid fa-envelope"></i>
                        </div>
                        <div>
                          <span style={{ display: 'block', fontWeight: '600', color: '#111827', fontSize: '0.9rem', textTransform: 'uppercase' }}>Email Address</span>
                          <a href="mailto:chennai@centralbooks.in" style={{ color: '#ea580c', fontWeight: '600' }}>chennai@centralbooks.in</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-service-area pt-100 pb-100" style={{ background: '#ffffff' }}>
        <div className="container">
          <div className="row justify-content-center text-center mb-60">
            <div className="col-xl-8 col-lg-9">
              <span className="it-section-subtitle-5 orange" style={{ fontSize: '1.1rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Comprehensive B2B Solutions</span>
              <h2 className="mt-15" style={{ fontSize: '2.3rem', fontWeight: '800', color: '#111827' }}>
                Library Solutions & Notebook Manufacturing — Now Available in Tamil Nadu
              </h2>
              <p className="mt-15" style={{ color: '#4b5563', fontSize: '1.1rem', lineHeight: '1.6' }}>
                Leverage our state-of-the-art notebook manufacturing facilities and library curation specialists to set up world-class learning spaces in Chennai. We handle design, custom cataloguing, and rapid production at scale.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-md-6 mb-30">
              <div className="p-40 text-center" style={{ background: '#f9fafb', borderRadius: '12px', border: '1px solid #f3f4f6', height: '100%', transition: 'all 0.3s ease' }}>
                <div style={{ width: '70px', height: '70px', background: 'rgba(234, 88, 12, 0.1)', color: '#ea580c', fontSize: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', margin: '0 auto 25px auto' }}>
                  <i className="fa-solid fa-book-open"></i>
                </div>
                <h4 style={{ fontSize: '1.35rem', fontWeight: '700', color: '#111827', marginBottom: '15px' }}>Custom Notebooks</h4>
                <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Locally branded, high-GSM paper notebooks with your school logo, specific ruling types, and customized front/back educational covers.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 mb-30">
              <div className="p-40 text-center" style={{ background: '#f9fafb', borderRadius: '12px', border: '1px solid #f3f4f6', height: '100%', transition: 'all 0.3s ease' }}>
                <div style={{ width: '70px', height: '70px', background: 'rgba(234, 88, 12, 0.1)', color: '#ea580c', fontSize: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', margin: '0 auto 25px auto' }}>
                  <i className="fa-solid fa-graduation-cap"></i>
                </div>
                <h4 style={{ fontSize: '1.35rem', fontWeight: '700', color: '#111827', marginBottom: '15px' }}>Curated Libraries</h4>
                <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Comprehensive curation lists covering K-12 literature, reference encyclopedias, Dewey Decimal classification, and cataloguing setup.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-12 mb-30">
              <div className="p-40 text-center" style={{ background: '#f9fafb', borderRadius: '12px', border: '1px solid #f3f4f6', height: '100%', transition: 'all 0.3s ease' }}>
                <div style={{ width: '70px', height: '70px', background: 'rgba(234, 88, 12, 0.1)', color: '#ea580c', fontSize: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', margin: '0 auto 25px auto' }}>
                  <i className="fa-solid fa-boxes-packing"></i>
                </div>
                <h4 style={{ fontSize: '1.35rem', fontWeight: '700', color: '#111827', marginBottom: '15px' }}>Custom School Kits</h4>
                <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Class-wise kits shrink-wrapped and labelled, combining textbooks, custom notebooks, stationery and uniform accessories in one hassle-free pack.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-value-area pt-100 pb-100" style={{ background: '#f9fafb' }}>
        <div className="container">
          <div className="row justify-content-center text-center mb-60">
            <div className="col-xl-8 col-lg-9">
              <span className="it-section-subtitle-5 orange" style={{ fontSize: '1.1rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Why Choose Us</span>
              <h2 className="mt-15" style={{ fontSize: '2.3rem', fontWeight: '800', color: '#111827' }}>
                Why Chennai Schools Choose CBS HUB as Their Institutional Supplier
              </h2>
              <p className="mt-15" style={{ color: '#4b5563', fontSize: '1.1rem', lineHeight: '1.6' }}>
                While competitors in Chennai offer category-specific products, CBS HUB serves as a unified partner covering the entire institutional spectrum.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-md-6 mb-30">
              <div style={{ background: '#ffffff', padding: '35px', borderRadius: '12px', border: '1px solid #e5e7eb', height: '100%' }}>
                <span style={{ fontSize: '2rem', fontWeight: '800', color: '#ea580c', opacity: '0.3', display: 'block', marginBottom: '15px' }}>01</span>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '10px' }}>Unified Procurement</h4>
                <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Get books, stationery, customized notebooks, and library setups from a single trusted provider instead of managing five different vendors.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 mb-30">
              <div style={{ background: '#ffffff', padding: '35px', borderRadius: '12px', border: '1px solid #e5e7eb', height: '100%' }}>
                <span style={{ fontSize: '2rem', fontWeight: '800', color: '#ea580c', opacity: '0.3', display: 'block', marginBottom: '15px' }}>02</span>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '10px' }}>Dedicated Logistics</h4>
                <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Robust supply chain network with regional shipping facilities ensuring that B2B school supplies are delivered on-schedule before the academic year starts.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-12 mb-30">
              <div style={{ background: '#ffffff', padding: '35px', borderRadius: '12px', border: '1px solid #e5e7eb', height: '100%' }}>
                <span style={{ fontSize: '2rem', fontWeight: '800', color: '#ea580c', opacity: '0.3', display: 'block', marginBottom: '15px' }}>03</span>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '10px' }}>75+ Years Trust</h4>
                <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Our rich operational history and solid publisher relations guarantee maximum stock availability even for high-demand curriculum publications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-faq-area pt-100 pb-100" style={{ background: '#ffffff' }}>
        <div className="container">
          <div className="row justify-content-center text-center mb-60">
            <div className="col-xl-8 col-lg-9">
              <span className="it-section-subtitle-5 orange" style={{ fontSize: '1.1rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Frequently Asked Questions</span>
              <h2 className="mt-15" style={{ fontSize: '2.3rem', fontWeight: '800', color: '#111827' }}>
                Chennai Branch FAQ
              </h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-9 col-lg-10">
              <div className="faq-wrapper">
                {faqData.map((faq, index) => (
                  <div key={index} className="faq-item mb-20" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                    <button
                      onClick={() => toggleFaq(index)}
                      style={{
                        width: '100%',
                        textAlign: 'left',
                        padding: '20px 25px',
                        background: '#f9fafb',
                        border: 'none',
                        outline: 'none',
                        display: 'flex',
                        justifyContent: 'between',
                        alignItems: 'center',
                        cursor: 'pointer',
                        fontWeight: '700',
                        color: '#111827',
                        fontSize: '1.1rem'
                      }}
                    >
                      <span style={{ flexGrow: 1 }}>{faq.question}</span>
                      <span style={{ color: '#ea580c', fontSize: '1.2rem', marginLeft: '15px' }}>
                        {activeFaq === index ? '−' : '+'}
                      </span>
                    </button>
                    {activeFaq === index && (
                      <div style={{ padding: '20px 25px', background: '#ffffff', borderTop: '1px solid #e5e7eb', color: '#4b5563', lineHeight: '1.7', fontSize: '1rem' }}>
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterTwo
        footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
        footerLogo={Logo}
        btnClass="it-btn-white sky-bg"
        copyrightTextClass="it-copyright-text inner-style text-center"
      />
    </main>
  );
};

export default ChennaiBranch;
